<div [ngStyle]="{ 'z-index': '0' }">
  <div [ngStyle]="{ bottom: 0, left: 0 }" class="u-position-absolute">
    <svg
      fill="none"
      height="208"
      viewBox="0 0 473 208"
      width="473"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="M241.703 151.852C241.703 151.852 241.703 151.852 241.703 151.852C241.703 174.966 222.965 193.703 199.851 193.703C176.737 193.703 158 174.966 158 151.852C158 128.738 176.737 110 199.851 110C199.851 110 199.851 110 199.852 110L199.852 110L241.703 110L241.703 151.852L241.703 151.852Z"
        fill="#B2DED2"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M241.703 151.852C241.703 151.852 241.703 151.852 241.703 151.852C241.703 174.966 222.965 193.703 199.851 193.703C176.737 193.703 158 174.966 158 151.852C158 128.738 176.737 110 199.851 110C199.851 110 199.851 110 199.852 110L199.852 110L241.703 110L241.703 151.852L241.703 151.852Z"
        fill="#B2DED2"
        fill-rule="evenodd"
      />
      <rect
        fill="#EBFCF8"
        height="196"
        rx="41.5"
        transform="rotate(-90 -54 83)"
        width="83"
        x="-54"
        y="83"
      />
      <rect
        fill="#C7EAE4"
        height="196"
        rx="41.5"
        transform="rotate(90 473 111)"
        width="83"
        x="473"
        y="111"
      />
      <rect
        fill="#BCE5FF"
        height="231.039"
        rx="41.7143"
        width="83.4286"
        x="44"
        y="97"
      />
    </svg>
  </div>
  <div [ngStyle]="{ top: 0, right: 0 }" class="u-position-absolute">
    <svg
      fill="none"
      height="298"
      viewBox="0 0 333 298"
      width="333"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="M295.703 120.852C295.703 120.852 295.703 120.852 295.703 120.852C295.703 143.966 276.965 162.703 253.851 162.703C230.737 162.703 212 143.966 212 120.852C212 97.7379 230.737 79.0004 253.851 79.0004C253.851 79.0004 253.851 79.0004 253.852 79.0004L253.852 79.0002L295.703 79.0002L295.703 120.852L295.703 120.852Z"
        fill="#B2DED2"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M295.703 120.852C295.703 120.852 295.703 120.852 295.703 120.852C295.703 143.966 276.965 162.703 253.851 162.703C230.737 162.703 212 143.966 212 120.852C212 97.7379 230.737 79.0004 253.851 79.0004C253.851 79.0004 253.851 79.0004 253.852 79.0004L253.852 79.0002L295.703 79.0002L295.703 120.852L295.703 120.852Z"
        fill="#B2DED2"
        fill-rule="evenodd"
      />
      <rect
        fill="#C7EAE4"
        height="196"
        rx="41.5"
        transform="rotate(-90 0 52)"
        width="83"
        y="52"
      />
      <rect
        fill="#EBFCF8"
        height="231.039"
        rx="41.7143"
        width="83.4286"
        x="98"
        y="66"
      />
      <path
        clip-rule="evenodd"
        d="M372.983 9.85177C372.983 32.9656 354.245 51.7031 331.131 51.7031L266.851 51.7031C243.737 51.7031 225 32.9656 225 9.85178C225 -13.2621 243.737 -31.9996 266.851 -31.9996L331.131 -31.9996L331.131 -31.9996L331.131 -31.9998L372.982 -31.9998L372.982 9.71661C372.983 9.76165 372.983 9.8067 372.983 9.85177Z"
        fill="#BCE5FF"
        fill-rule="evenodd"
      />
    </svg>
  </div>
</div>
